<template>
  <v-container fluid class="asistencia-page pa-2 pa-md-3">
    <v-card flat class="page-card">
      <div class="page-header px-3 px-md-4 pt-3 pb-2">
        <div class="page-header__text">
          <h1 class="page-title">Asistencia alumnos</h1>
          <p class="page-subtitle mb-0">
            <span v-if="cicloNombre">{{ cicloNombre }}</span>
            <span v-else>Ciclo actual</span>
            <span class="page-subtitle__dot">·</span>
            {{ cargandoLista ? 'cargando alumnos...' : alumnosFiltrados.length + ' alumnos' }}
          </p>
        </div>
        <div class="page-actions">
          <div class="page-actions__meta">
            {{ textoUltimaActualizacion }}
          </div>
          <v-btn
            class="page-actions__btn"
            small
            dark
            color="indigo"
            :disabled="!listaalumnos.length || cargandoLista"
            @click="abrirReporte()"
          >
            <v-icon left small>mdi-chart-box-outline</v-icon>
            Reporte
          </v-btn>
          <v-btn
            class="page-actions__btn"
            small
            dark
            color="green"
            :disabled="!alumnosFiltrados.length || cargandoLista"
            @click="exportarAlumnos()"
          >
            <v-icon left small>mdi-microsoft-excel</v-icon>
            Excel
          </v-btn>
          <v-btn
            class="page-actions__btn"
            small
            outlined
            color="primary"
            :loading="cargandoLista"
            :disabled="cargandoLista"
            @click="cargarAlumnos()"
          >
            <v-icon left small>mdi-refresh</v-icon>
            Actualizar
          </v-btn>
        </div>
      </div>

      <v-divider></v-divider>

      <v-card-text class="px-3 px-md-4 py-3">
        <v-row dense class="filters-row" align="center">
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-autocomplete
              v-model="idCicloSeleccionado"
              :items="ciclos"
              item-text="ciclo"
              item-value="id_ciclo"
              label="Ciclo"
              outlined
              dense
              hide-details
              :loading="cargandoCiclos"
              prepend-inner-icon="mdi-calendar-range"
              no-data-text="Sin ciclos"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fecha"
                  label="Fecha"
                  outlined
                  dense
                  hide-details
                  readonly
                  prepend-inner-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fecha"
                no-title
                scrollable
                :allowed-dates="fechasHabiles"
                :min="fechaMin"
                :max="fechaMax"
                color="primary"
                @input="menu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field
              v-model="search"
              label="Buscar alumno"
              placeholder="Nombre o matrícula..."
              outlined
              dense
              hide-details
              clearable
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-autocomplete
              v-model="plantel"
              :items="plantelesUnicos"
              label="Plantel"
              outlined
              dense
              hide-details
              clearable
              item-text="nombre"
              item-value="id"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-autocomplete
              v-model="nivel"
              :items="nivelesUnicos"
              label="Nivel"
              outlined
              dense
              hide-details
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-select
              v-model="filtroAsistencia"
              :items="opcionesAsistencia"
              label="Registro"
              outlined
              dense
              hide-details
              clearable
              item-text="texto"
              item-value="valor"
            ></v-select>
          </v-col>
        </v-row>

        <div class="d-flex align-center flex-wrap mt-3 mb-1">
          <span class="caption grey--text mr-3">Alumno</span>
          <v-chip small color="#c62828" dark class="mr-1 mb-1">{{ textoDebe }}</v-chip>
          <v-chip small color="#2e7d32" dark class="mr-1 mb-1">{{ textoYaPagado }}</v-chip>
          <v-chip small color="#6a1b9a" dark class="mr-3 mb-1">Becado</v-chip>
          <span class="caption grey--text mr-3">Asistencia</span>
          <v-chip small outlined color="success" class="mr-1 mb-1">A · Asistencia</v-chip>
          <v-chip small outlined color="error" class="mb-1">F · Falta</v-chip>
        </div>

        <v-alert
          v-if="mensajeLista"
          dense
          outlined
          type="info"
          class="mt-2 mb-2"
        >
          {{ mensajeLista }}
        </v-alert>

        <v-data-table
          :headers="headersAlumnosTabla"
          :items="alumnosFiltrados"
          item-key="clave"
          class="asistencia-table mt-2"
          height="calc(100vh - 250px)"
          dense
          fixed-header
          :item-class="claseFilaAlumno"
          :loading="cargandoLista"
          loading-text="Cargando alumnos del ciclo..."
          :mobile-breakpoint="100"
          :footer-props="{
            'items-per-page-options': [25, 50, 100, -1],
            showFirstLastPage: true,
          }"
        >
          <template v-slot:progress>
            <v-progress-linear
              color="primary"
              indeterminate
              height="3"
            ></v-progress-linear>
          </template>

          <template v-slot:item.alumno="{ item }">
            <div class="py-1 d-flex align-center">
              <div>
                <div class="alumno-nombre">{{ item.alumno }}</div>
                <div class="alumno-matricula">{{ item.matricula || '—' }}</div>
              </div>
              <span class="ml-2 d-inline-flex icono-telefono" @click.stop="abrirTelefono(item)">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small color="teal" v-bind="attrs" v-on="on">mdi-cellphone</v-icon>
                  </template>
                  <span>Ver teléfono</span>
                </v-tooltip>
              </span>
              <v-tooltip v-if="item.es_hermano" bottom max-width="280">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="indigo"
                    class="ml-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-account-multiple
                  </v-icon>
                </template>
                <span>{{ textoHermanos(item) }}</span>
              </v-tooltip>
            </div>
          </template>

          <template v-slot:item.grupo="{ item }">
            <span class="texto-tabla">{{ item.grupo }}</span>
          </template>

          <template v-slot:item.estatus_pago="{ item }">
            <v-chip
              small
              dark
              :color="colorEstatusPago(item)"
            >
              {{ textoEstatusPago(item) }}
            </v-chip>
          </template>

          <template v-slot:item.monto_cobrar="{ item }">
            <span class="monto-texto">{{ formatoMonto(item.monto_cobrar) }}</span>
          </template>

          <template v-slot:item.monto_pagar="{ item }">
            <v-text-field
              v-model="item.monto_pagar"
              type="text"
              inputmode="decimal"
              prefix="$"
              placeholder="0.00"
              dense
              filled
              hide-details
              class="monto-input"
              :loading="!!item._guardandoIntencion"
              :disabled="!!item._guardandoIntencion"
              @blur="onBlurMonto(item)"
              @keydown.enter.prevent="onBlurMonto(item)"
            ></v-text-field>
          </template>

          <template v-slot:item.feria="{ item }">
            <v-chip
              v-if="feriaAlumno(item)"
              small
              dark
              :color="colorFeria(item)"
            >
              {{ textoFeria(item) }}
            </v-chip>
            <span v-else class="grey--text">—</span>
          </template>

          <template v-slot:item.id_forma_pago="{ item }">
            <v-select
              v-model="item.id_forma_pago"
              :items="formasPago"
              item-text="forma_pago"
              item-value="id_forma_pago"
              :placeholder="item.metodo_pago || 'Método'"
              dense
              filled
              hide-details
              clearable
              class="metodo-input"
              :loading="!!item._guardandoIntencion"
              :disabled="!!item._guardandoIntencion"
              @change="onCambioMetodo(item)"
            ></v-select>
          </template>

          <template v-slot:item.notas="{ item }">
            <v-text-field
              v-model="item.notas"
              placeholder="Escribir nota..."
              dense
              filled
              hide-details
              class="nota-input"
              :loading="!!item._guardandoNota"
              :disabled="!!item._guardandoNota"
              @blur="onBlurNota(item)"
              @keydown.enter.prevent="onBlurNota(item)"
            ></v-text-field>
          </template>

          <template v-slot:item.comentarios_calidad="{ item }">
            <v-text-field
              v-model="item.comentarios_calidad"
              placeholder="Comentario calidad..."
              dense
              filled
              hide-details
              class="nota-input"
              :loading="!!item._guardandoComentarioCalidad"
              :disabled="!!item._guardandoComentarioCalidad"
              @blur="onBlurComentarioCalidad(item)"
              @keydown.enter.prevent="onBlurComentarioCalidad(item)"
            ></v-text-field>
          </template>

          <template v-slot:item.asistencia="{ item }">
            <div class="d-flex align-center asistencia-radios-wrap">
              <v-radio-group
                row
                dense
                hide-details
                class="mt-0 pt-0 asistencia-radios"
                v-model="item.valor_asistencia"
                :disabled="!!item._guardando"
                @change="onCambioAsistencia(item)"
              >
                <v-radio color="success" :value="1">
                  <template v-slot:label>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span class="asistencia-letra success--text" v-bind="attrs" v-on="on">A</span>
                      </template>
                      <span>Asistencia</span>
                    </v-tooltip>
                  </template>
                </v-radio>
                <v-radio color="error" :value="2">
                  <template v-slot:label>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span class="asistencia-letra error--text" v-bind="attrs" v-on="on">F</span>
                      </template>
                      <span>Falta</span>
                    </v-tooltip>
                  </template>
                </v-radio>
              </v-radio-group>
              <v-icon v-if="item._guardando" x-small class="ml-1" color="grey">mdi-loading</v-icon>
              <v-icon v-else-if="item._errorGuardado" x-small class="ml-1" color="error">mdi-alert-circle</v-icon>
            </div>
          </template>

          <template v-slot:no-data>
            <div class="py-8 text-center grey--text text--darken-1">
              <v-icon large color="grey lighten-1" class="mb-2">mdi-table-search</v-icon>
              <div class="body-2">
                {{ mensajeTabla }}
              </div>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogReporte" max-width="980">
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-medium pb-1">
          Reporte por plantel
        </v-card-title>
        <v-card-subtitle class="pb-2">
          {{ cicloNombre || 'Ciclo actual' }}
          <span class="page-subtitle__dot">·</span>
          {{ fecha }}
        </v-card-subtitle>
        <v-card-text>
          <v-row dense class="mb-3" align="center">
            <v-col cols="12" sm="6" md="4">
              <v-select
                v-model="filtroEscuelaReporte"
                :items="opcionesEscuelaReporte"
                label="Escuela"
                outlined
                dense
                hide-details
                clearable
                item-text="texto"
                item-value="id"
              ></v-select>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headersReporte"
            :items="filasReporte"
            item-key="id_plantel"
            class="asistencia-table"
            dense
            :items-per-page="-1"
            hide-default-footer
            :mobile-breakpoint="0"
          >
            <template v-slot:item.alumnos="{ item }">
              <v-chip
                small
                dark
                color="primary"
                class="chip-reporte"
                :disabled="!item.alumnos"
                @click="abrirAlumnosReporte(item, 'alumnos')"
              >
                {{ item.alumnos }}
              </v-chip>
            </template>
            <template v-slot:item.pagados="{ item }">
              <v-chip
                small
                dark
                color="#2e7d32"
                class="chip-reporte"
                :disabled="!item.pagados"
                @click="abrirAlumnosReporte(item, 'pagados')"
              >
                {{ item.pagados }}
              </v-chip>
            </template>
            <template v-slot:item.sin_pago="{ item }">
              <v-chip
                small
                dark
                color="#c62828"
                class="chip-reporte"
                :disabled="!item.sin_pago"
                @click="abrirAlumnosReporte(item, 'sin_pago')"
              >
                {{ item.sin_pago }}
              </v-chip>
            </template>
            <template v-slot:item.asistieron="{ item }">
              <v-chip
                small
                dark
                color="success"
                class="chip-reporte"
                :disabled="!item.asistieron"
                @click="abrirAlumnosReporte(item, 'asistieron')"
              >
                {{ item.asistieron }}
              </v-chip>
            </template>
            <template v-slot:item.faltaron="{ item }">
              <v-chip
                small
                dark
                color="error"
                class="chip-reporte"
                :disabled="!item.faltaron"
                @click="abrirAlumnosReporte(item, 'faltaron')"
              >
                {{ item.faltaron }}
              </v-chip>
            </template>
            <template v-slot:item.con_registro_pago="{ item }">
              <v-chip
                small
                dark
                color="teal"
                class="chip-reporte"
                :disabled="!item.con_registro_pago"
                @click="abrirAlumnosReporte(item, 'con_registro_pago')"
              >
                {{ item.con_registro_pago }}
              </v-chip>
            </template>
            <template v-slot:body.append>
              <tr class="reporte-total">
                <td>TOTAL</td>
                <td class="text-end">
                  <v-chip
                    small
                    dark
                    color="primary"
                    class="chip-reporte"
                    :disabled="!totalesReporte.alumnos"
                    @click="abrirAlumnosReporte(null, 'alumnos')"
                  >
                    {{ totalesReporte.alumnos }}
                  </v-chip>
                </td>
                <td class="text-end">
                  <v-chip
                    small
                    dark
                    color="#2e7d32"
                    class="chip-reporte"
                    :disabled="!totalesReporte.pagados"
                    @click="abrirAlumnosReporte(null, 'pagados')"
                  >
                    {{ totalesReporte.pagados }}
                  </v-chip>
                </td>
                <td class="text-end">
                  <v-chip
                    small
                    dark
                    color="#c62828"
                    class="chip-reporte"
                    :disabled="!totalesReporte.sin_pago"
                    @click="abrirAlumnosReporte(null, 'sin_pago')"
                  >
                    {{ totalesReporte.sin_pago }}
                  </v-chip>
                </td>
                <td class="text-end">
                  <v-chip
                    small
                    dark
                    color="success"
                    class="chip-reporte"
                    :disabled="!totalesReporte.asistieron"
                    @click="abrirAlumnosReporte(null, 'asistieron')"
                  >
                    {{ totalesReporte.asistieron }}
                  </v-chip>
                </td>
                <td class="text-end">
                  <v-chip
                    small
                    dark
                    color="error"
                    class="chip-reporte"
                    :disabled="!totalesReporte.faltaron"
                    @click="abrirAlumnosReporte(null, 'faltaron')"
                  >
                    {{ totalesReporte.faltaron }}
                  </v-chip>
                </td>
                <td class="text-end">
                  <v-chip
                    small
                    dark
                    color="teal"
                    class="chip-reporte"
                    :disabled="!totalesReporte.con_registro_pago"
                    @click="abrirAlumnosReporte(null, 'con_registro_pago')"
                  >
                    {{ totalesReporte.con_registro_pago }}
                  </v-chip>
                </td>
              </tr>
            </template>
            <template v-slot:no-data>
              <div class="py-6 text-center grey--text">Sin alumnos para el reporte</div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small text @click="dialogReporte = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAlumnosReporte" max-width="920">
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-medium pb-1">
          {{ tituloDetalleReporte }}
        </v-card-title>
        <v-card-subtitle class="pb-2">
          {{ alumnosDetalleReporte.length }} alumnos
        </v-card-subtitle>
        <v-card-text>
          <v-text-field
            v-model="buscaDetalleReporte"
            label="Buscar alumno"
            placeholder="Nombre o matrícula..."
            outlined
            dense
            hide-details
            clearable
            class="mb-3"
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
          <v-data-table
            :headers="headersDetalleReporte"
            :items="alumnosDetalleFiltrados"
            item-key="clave"
            class="asistencia-table"
            dense
            :item-class="claseFilaAlumno"
            :footer-props="{
              'items-per-page-options': [25, 50, 100, -1],
              showFirstLastPage: true,
            }"
            :mobile-breakpoint="0"
          >
            <template v-slot:item.estatus_pago="{ item }">
              <v-chip small dark :color="colorEstatusPago(item)">
                {{ textoEstatusPago(item) }}
              </v-chip>
            </template>
            <template v-slot:item.monto_pagar="{ item }">
              <span class="monto-texto">{{ formatoMonto(item.monto_pagar) }}</span>
            </template>
            <template v-slot:item.id_forma_pago="{ item }">
              <span>{{ nombreFormaPago(item.id_forma_pago) || '—' }}</span>
            </template>
            <template v-slot:item.asistencia="{ item }">
              <span>{{ textoAsistencia(item) }}</span>
            </template>
            <template v-slot:no-data>
              <div class="py-6 text-center grey--text">Sin alumnos en este dato</div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small text @click="dialogAlumnosReporte = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTelefono" max-width="420">
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-medium">
          Teléfono del alumno
        </v-card-title>
        <v-card-text>
          <div class="alumno-nombre mb-3">{{ alumnoTelefono.alumno || '—' }}</div>
          <div v-if="alumnoTelefono.celular" class="mb-2">
            <div class="caption grey--text">Celular</div>
            <div class="text-h6">{{ alumnoTelefono.celular }}</div>
          </div>
          <div v-if="alumnoTelefono.telefono && alumnoTelefono.telefono !== alumnoTelefono.celular" class="mb-2">
            <div class="caption grey--text">Teléfono</div>
            <div class="text-h6">{{ alumnoTelefono.telefono }}</div>
          </div>
          <div v-if="!alumnoTelefono.celular && !alumnoTelefono.telefono" class="grey--text">
            Sin número registrado
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small text @click="dialogTelefono = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Alerta from '@/components/alertas/Alerta.vue';
import validarErrores from '@/mixins/validarErrores';
import funcionesExcel from '@/mixins/funcionesExcel';
import { puedeVerComentariosCalidad } from '@/utils/permisosAsistenciaAlumnos';

export default {
  name: 'AsistenciaAlumnos',

  components: {
    Alerta,
  },

  mixins: [validarErrores, funcionesExcel],

  data: function () {
    return {
      parametros: {
        dialogError: false,
        mensaje: '',
        color: '',
      },
      respuestaAlerta: false,
      cargandoLista: false,
      consultaListaId: 0,
      search: '',
      ciclo: null,
      cicloNombre: '',
      cicloSiguienteNombre: '',
      ciclos: [],
      idCicloSeleccionado: null,
      cargandoCiclos: false,
      omitirWatchCiclo: false,
      mensajeLista: '',
      niveles: [],
      nivel: null,
      plantel: null,
      filtroAsistencia: null,
      opcionesAsistencia: [
        { valor: 'asistencia', texto: 'Asistencia' },
        { valor: 'falta', texto: 'Falta' },
        { valor: 'sin_registro', texto: 'Sin registro' },
      ],
      formasPago: [
        { id_forma_pago: 1, forma_pago: 'EFECTIVO' },
        { id_forma_pago: 2, forma_pago: 'DEPOSITO' },
        { id_forma_pago: 6, forma_pago: 'TRANSFERENCIA' },
        { id_forma_pago: 4, forma_pago: 'TARJETA' },
      ],
      listaalumnos: [],
      headersAlumnosBase: [
        { text: 'Alumno', value: 'alumno', sortable: true },
        { text: 'Grupo', value: 'grupo', sortable: true },
        { text: 'Pago siguiente', value: 'estatus_pago', align: 'center', sortable: true, width: '200px' },
        { text: 'Monto a pagar', value: 'monto_cobrar', align: 'end', sortable: true, width: '140px' },
        { text: 'Pago del cliente', value: 'monto_pagar', sortable: false, width: '150px' },
        { text: 'Feria / Cambio / Saldo a favor', value: 'feria', align: 'end', sortable: false, width: '220px' },
        { text: 'Método', value: 'id_forma_pago', sortable: false, width: '220px' },
        { text: 'Notas', value: 'notas', sortable: false, width: '220px' },
        { text: 'Asistencia', value: 'asistencia', align: 'center', sortable: false, width: '140px' },
      ],
      fecha: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      fechaMin: null,
      fechaMax: null,
      fechas: [],
      omitirWatchFecha: false,
      dialogTelefono: false,
      dialogReporte: false,
      dialogAlumnosReporte: false,
      ultimaActualizacion: null,
      filtroEscuelaReporte: null,
      buscaDetalleReporte: '',
      tituloDetalleReporte: '',
      alumnosDetalleReporte: [],
      opcionesEscuelaReporte: [
        { id: 1, texto: 'INBI' },
        { id: 2, texto: 'FAST' },
      ],
      headersReporte: [
        { text: 'Plantel', value: 'plantel', sortable: true },
        { text: 'Alumnos', value: 'alumnos', align: 'end', sortable: true },
        { text: 'Pagados', value: 'pagados', align: 'end', sortable: true },
        { text: 'Sin pago', value: 'sin_pago', align: 'end', sortable: true },
        { text: 'Asistieron', value: 'asistieron', align: 'end', sortable: true },
        { text: 'Faltaron', value: 'faltaron', align: 'end', sortable: true },
        { text: 'Con registro de pago', value: 'con_registro_pago', align: 'end', sortable: true },
      ],
      headersDetalleReporte: [
        { text: 'Alumno', value: 'alumno', sortable: true },
        { text: 'Matrícula', value: 'matricula', sortable: true },
        { text: 'Grupo', value: 'grupo', sortable: true },
        { text: 'Pago siguiente', value: 'estatus_pago', sortable: true },
        { text: 'Pago del cliente', value: 'monto_pagar', align: 'end', sortable: true },
        { text: 'Método', value: 'id_forma_pago', sortable: true },
        { text: 'Asistencia', value: 'asistencia', sortable: true },
      ],
      alumnoTelefono: {
        alumno: '',
        celular: '',
        telefono: '',
      },
    };
  },

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),

    puedeVerComentariosCalidad: function () {
      var u = this.getdatosUsuarioERPERP || {};
      return puedeVerComentariosCalidad(u.iderp);
    },

    headersAlumnosTabla: function () {
      var headers = this.headersAlumnosBase.slice();
      if (this.puedeVerComentariosCalidad) {
        var idx = headers.findIndex(function (h) {
          return h.value === 'notas';
        });
        var columna = {
          text: 'Comentarios calidad',
          value: 'comentarios_calidad',
          sortable: false,
          width: '220px',
        };
        if (idx === -1) {
          headers.push(columna);
        } else {
          headers.splice(idx + 1, 0, columna);
        }
      }
      return headers;
    },

    plantelesUsuario: function () {
      var ids = [];
      var u = this.getdatosUsuarioERPERP;
      if (u && Array.isArray(u.planteles)) {
        u.planteles.forEach(function (registro) {
          ids.push(registro && registro.idplantel);
        });
      }
      if (u && u.id_plantel) {
        ids.push(u.id_plantel);
      }
      var vistos = {};
      var out = [];
      ids.forEach(function (raw) {
        var n = Number(raw);
        if (!n || vistos[n]) return;
        vistos[n] = true;
        out.push(n);
      });
      return out;
    },

    plantelesUnicos: function () {
      var vistos = {};
      var lista = [];
      this.listaalumnos.forEach(function (a) {
        var id = Number(a.id_plantel);
        if (!id || vistos[id]) return;
        vistos[id] = true;
        lista.push({
          id: id,
          nombre: a.plantel || ('Plantel ' + id),
        });
      });
      lista.sort(function (a, b) {
        return String(a.nombre).localeCompare(String(b.nombre), 'es');
      });
      return lista;
    },

    nivelesUnicos: function () {
      var vistos = {};
      return this.niveles.filter(function (n) {
        if (!n || vistos[n]) return false;
        vistos[n] = true;
        return true;
      });
    },

    numeroCicloSiguiente: function () {
      var fuente = this.cicloSiguienteNombre || '';
      var match = String(fuente).match(/(\d+)/);
      if (match && match[1]) {
        var n = String(parseInt(match[1], 10));
        if (n.length === 1) n = '0' + n;
        return n;
      }
      var actual = String(this.cicloNombre || '').match(/(\d+)/);
      if (actual && actual[1]) {
        var siguiente = String(parseInt(actual[1], 10) + 1);
        if (siguiente.length === 1) siguiente = '0' + siguiente;
        return siguiente;
      }
      return '';
    },

    textoDebe: function () {
      return this.numeroCicloSiguiente
        ? 'Debe ciclo ' + this.numeroCicloSiguiente
        : 'Debe';
    },

    textoYaPagado: function () {
      return this.numeroCicloSiguiente
        ? 'Ya pagó Ciclo ' + this.numeroCicloSiguiente
        : 'Ya pagó';
    },

    alumnosFiltrados: function () {
      var lista = this.listaalumnos.slice();
      var busca = this.normalizarTexto(this.search);

      if (this.plantel) {
        lista = lista.filter(function (el) {
          return Number(el.id_plantel) === Number(this.plantel);
        }, this);
      }

      if (this.nivel) {
        lista = lista.filter(function (el) {
          return el.id_nivel == this.nivel;
        }, this);
      }

      if (this.filtroAsistencia) {
        lista = lista.filter(function (el) {
          var valor = Number(el.valor_asistencia);
          if (this.filtroAsistencia === 'asistencia') return valor === 1;
          if (this.filtroAsistencia === 'falta') return valor === 2;
          return valor !== 1 && valor !== 2;
        }, this);
      }

      if (busca) {
        lista = lista.filter(function (el) {
          var nombre = this.normalizarTexto(el.alumno);
          var matricula = this.normalizarTexto(el.matricula);
          return nombre.indexOf(busca) !== -1 || matricula.indexOf(busca) !== -1;
        }, this);
      }

      return lista;
    },

    alumnosReporte: function () {
      var lista = this.listaalumnos.slice();
      if (this.filtroEscuelaReporte) {
        lista = lista.filter(function (el) {
          return Number(el.escuela || el.id_unidad_negocio) === Number(this.filtroEscuelaReporte);
        }, this);
      }
      return lista;
    },

    filasReporte: function () {
      var mapa = {};
      var lista = this.alumnosReporte;
      for (var i = 0; i < lista.length; i++) {
        var a = lista[i];
        var id = Number(a.id_plantel) || 0;
        if (!mapa[id]) {
          mapa[id] = {
            id_plantel: id,
            plantel: a.plantel || 'Sin plantel',
            alumnos: 0,
            pagados: 0,
            sin_pago: 0,
            asistieron: 0,
            faltaron: 0,
            con_registro_pago: 0,
          };
        }
        var row = mapa[id];
        row.alumnos += 1;
        if (a.estatus_pago === 'si') {
          row.pagados += 1;
        } else {
          row.sin_pago += 1;
        }
        var asist = Number(a.valor_asistencia);
        if (asist === 1) row.asistieron += 1;
        if (asist === 2) row.faltaron += 1;
        if (this.tieneRegistroPago(a)) row.con_registro_pago += 1;
      }
      var filas = Object.keys(mapa).map(function (k) {
        return mapa[k];
      });
      filas.sort(function (a, b) {
        return String(a.plantel).localeCompare(String(b.plantel), 'es');
      });
      return filas;
    },

    totalesReporte: function () {
      var total = {
        alumnos: 0,
        pagados: 0,
        sin_pago: 0,
        asistieron: 0,
        faltaron: 0,
        con_registro_pago: 0,
      };
      this.filasReporte.forEach(function (row) {
        total.alumnos += row.alumnos;
        total.pagados += row.pagados;
        total.sin_pago += row.sin_pago;
        total.asistieron += row.asistieron;
        total.faltaron += row.faltaron;
        total.con_registro_pago += row.con_registro_pago;
      });
      return total;
    },

    textoUltimaActualizacion: function () {
      var u = this.ultimaActualizacion;
      if (!u || !u.fecha) return 'Sin actualizaciones';
      var d = new Date(String(u.fecha).replace(' ', 'T'));
      var fecha = isNaN(d.getTime())
        ? String(u.fecha)
        : d.toLocaleString('es-MX', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          });
      var quien = u.usuario ? u.usuario : 'Usuario';
      return 'Última actualización: ' + fecha + ' · ' + quien;
    },

    alumnosDetalleFiltrados: function () {
      var busca = this.normalizarTexto(this.buscaDetalleReporte);
      if (!busca) return this.alumnosDetalleReporte;
      return this.alumnosDetalleReporte.filter(function (el) {
        var nombre = this.normalizarTexto(el.alumno);
        var matricula = this.normalizarTexto(el.matricula);
        return nombre.indexOf(busca) !== -1 || matricula.indexOf(busca) !== -1;
      }, this);
    },

    mensajeTabla: function () {
      if (this.cargandoLista) {
        return 'Cargando alumnos del ciclo...';
      }
      if (this.mensajeLista) {
        return this.mensajeLista;
      }
      if (this.search && this.listaalumnos.length && !this.alumnosFiltrados.length) {
        return 'Ningún alumno coincide con la búsqueda';
      }
      return 'Sin alumnos en el ciclo actual';
    },
  },

  watch: {
    fecha: function (nueva, anterior) {
      if (this.omitirWatchFecha) {
        this.omitirWatchFecha = false;
        return;
      }
      if (nueva && nueva !== anterior) {
        this.cargarAlumnos();
      }
    },
    idCicloSeleccionado: function (nueva, anterior) {
      if (this.omitirWatchCiclo) {
        this.omitirWatchCiclo = false;
        return;
      }
      if (nueva && nueva !== anterior) {
        var sel = this.cicloPorId(nueva);
        if (sel && sel.ciclo) {
          this.cicloNombre = sel.ciclo;
        }
        this.cargarAlumnos();
      }
    },
  },

  created: function () {
    var self = this;
    this.cargarCiclos().then(function () {
      self.cargarAlumnos();
    });
  },

  methods: {
    cicloPorId: function (idCiclo) {
      var id = Number(idCiclo);
      if (!id) return null;
      for (var i = 0; i < this.ciclos.length; i++) {
        if (Number(this.ciclos[i].id_ciclo) === id) {
          return this.ciclos[i];
        }
      }
      return null;
    },

    cargarCiclos: function () {
      var self = this;
      self.cargandoCiclos = true;
      return self.$http
        .get('roles.ciclos.all')
        .then(function (response) {
          var lista = [];
          var rows = response.data || [];
          for (var i = 0; i < rows.length; i++) {
            var row = rows[i];
            if (!row || !row.ciclo) continue;
            var nombre = String(row.ciclo);
            if (nombre.indexOf('FE') !== -1) continue;
            if (nombre.indexOf('CICLO') === -1) continue;
            lista.push(row);
          }
          self.ciclos = lista;
        })
        .catch(function (error) {
          self.validarError(
            self.obtenerMensajeError(error, 'No se pudieron cargar los ciclos')
          );
        })
        .finally(function () {
          self.cargandoCiclos = false;
        });
    },

    normalizarTexto: function (texto) {
      if (!texto) return '';
      return String(texto)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, ' ');
    },

    obtenerMensajeError: function (error, mensajeDefault) {
      if (error && error.body && error.body.message) {
        return error.body.message;
      }
      return error &&
        error.response &&
        error.response.data &&
        error.response.data.message
        ? error.response.data.message
        : mensajeDefault;
    },

    fechasHabiles: function (val) {
      if (!this.fechas.length) return true;
      return this.fechas.indexOf(val) !== -1;
    },

    colorEstatusPago: function (item) {
      if (item && item.es_becado) return '#6a1b9a';
      if (item && item.estatus_pago === 'si') return '#2e7d32';
      return '#c62828';
    },

    textoEstatusPago: function (item) {
      if (item && item.es_becado) return 'Becado';
      if (item && item.estatus_pago === 'si') return this.textoYaPagado;
      return this.textoDebe;
    },

    claseFilaAlumno: function (item) {
      if (!item || item.estatus_pago == null) return '';
      if (item.es_becado) return 'fila-becado';
      if (item.estatus_pago === 'si') return 'fila-pagado';
      return 'fila-debe';
    },

    nombreFormaPago: function (idForma) {
      var id = Number(idForma);
      if (!id) return '';
      var found = this.formasPago.find(function (f) {
        return Number(f.id_forma_pago) === id;
      });
      return found && found.forma_pago ? found.forma_pago : '';
    },

    textoHermanos: function (item) {
      if (!item || !Array.isArray(item.hermanos) || !item.hermanos.length) {
        return '';
      }
      return item.hermanos.join(', ');
    },

    idCicloActividad: function () {
      if (this.ciclo && this.ciclo.id_ciclo) return this.ciclo.id_ciclo;
      return null;
    },

    aplicarUltimaActualizacion: function (data) {
      if (data && data.ultima_actualizacion) {
        this.ultimaActualizacion = data.ultima_actualizacion;
      }
    },

    tieneRegistroPago: function (item) {
      if (!item) return false;
      if (item.id_forma_pago) return true;
      return item.monto_pagar != null && item.monto_pagar !== '';
    },

    abrirReporte: function () {
      this.filtroEscuelaReporte = null;
      this.dialogReporte = true;
    },

    textoMetricaReporte: function (metrica) {
      if (metrica === 'pagados') return 'Pagados';
      if (metrica === 'sin_pago') return 'Sin pago';
      if (metrica === 'asistieron') return 'Asistieron';
      if (metrica === 'faltaron') return 'Faltaron';
      if (metrica === 'con_registro_pago') return 'Con registro de pago';
      return 'Alumnos';
    },

    filtrarMetricaReporte: function (lista, metrica) {
      var self = this;
      if (metrica === 'pagados') {
        return lista.filter(function (a) {
          return a.estatus_pago === 'si';
        });
      }
      if (metrica === 'sin_pago') {
        return lista.filter(function (a) {
          return a.estatus_pago !== 'si';
        });
      }
      if (metrica === 'asistieron') {
        return lista.filter(function (a) {
          return Number(a.valor_asistencia) === 1;
        });
      }
      if (metrica === 'faltaron') {
        return lista.filter(function (a) {
          return Number(a.valor_asistencia) === 2;
        });
      }
      if (metrica === 'con_registro_pago') {
        return lista.filter(function (a) {
          return self.tieneRegistroPago(a);
        });
      }
      return lista;
    },

    abrirAlumnosReporte: function (item, metrica) {
      var lista = this.alumnosReporte.slice();
      if (item) {
        lista = lista.filter(function (a) {
          return (Number(a.id_plantel) || 0) === Number(item.id_plantel);
        });
      }
      lista = this.filtrarMetricaReporte(lista, metrica);
      var plantel = item && item.plantel ? item.plantel : 'TOTAL';
      this.tituloDetalleReporte = plantel + ' · ' + this.textoMetricaReporte(metrica);
      this.buscaDetalleReporte = '';
      this.alumnosDetalleReporte = lista;
      this.dialogAlumnosReporte = true;
    },

    abrirTelefono: function (item) {
      this.alumnoTelefono = {
        alumno: item && item.alumno ? item.alumno : '',
        celular: item && item.celular ? item.celular : '',
        telefono: item && item.telefono ? item.telefono : '',
      };
      this.dialogTelefono = true;
    },

    formatoMonto: function (valor) {
      var num = this.normalizarMonto(valor);
      if (num == null) return '—';
      return (
        '$' +
        num.toLocaleString('es-MX', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
    },

    feriaAlumno: function (item) {
      if (!item) return null;
      var pagar = this.normalizarMonto(item.monto_pagar);
      var cobrar = this.normalizarMonto(item.monto_cobrar);
      if (pagar == null && cobrar == null) return null;
      if (pagar == null) pagar = 0;
      if (cobrar == null) cobrar = 0;
      var diff = Math.round((pagar - cobrar) * 100) / 100;
      if (diff === 0) return null;
      if (diff > 0) {
        return { tipo: 'favor', monto: diff };
      }
      return { tipo: 'debe', monto: Math.abs(diff) };
    },

    colorFeria: function (item) {
      var feria = this.feriaAlumno(item);
      if (!feria) return 'grey';
      if (feria.tipo === 'favor') return '#2e7d32';
      return '#c62828';
    },

    textoFeria: function (item) {
      var feria = this.feriaAlumno(item);
      if (!feria) return '—';
      if (feria.tipo === 'favor') {
        return 'Saldo a favor: ' + this.formatoMonto(feria.monto);
      }
      return 'Debe: ' + this.formatoMonto(feria.monto);
    },

    textoAsistencia: function (item) {
      var valor = Number(item && item.valor_asistencia);
      if (valor === 1) return 'Asistencia';
      if (valor === 2) return 'Falta';
      if (valor === 4) return 'Justificación';
      return 'Sin registrar';
    },

    cargarAlumnos: function () {
      var self = this;
      var requestId = ++this.consultaListaId;
      this.cargandoLista = true;
      this.mensajeLista = '';
      if (!this.plantelesUsuario.length) {
        this.listaalumnos = [];
        this.mensajeLista = 'No tienes sucursales asignadas';
        this.cargandoLista = false;
        return Promise.resolve();
      }
      var payload = {
        fecha: this.fecha,
        planteles: this.plantelesUsuario,
      };
      var cicloSel = this.cicloPorId(this.idCicloSeleccionado);
      if (cicloSel && cicloSel.id_ciclo && cicloSel.id_ciclo_relacionado) {
        payload.id_ciclo = cicloSel.id_ciclo;
        payload.id_ciclo_relacionado = cicloSel.id_ciclo_relacionado;
      }
      return this.$http
        .post('grupos.asistencias.ciclo', payload)
        .then(function (response) {
          if (requestId !== self.consultaListaId) {
            return;
          }
          var data = response.data || {};
          var alumnos = Array.isArray(data.alumnos) ? data.alumnos : [];
          var fechas = Array.isArray(data.fechas) ? data.fechas : [];
          self.ciclo = data.ciclo || null;
          var nombreResp =
            data.ciclo && data.ciclo.ciclo ? data.ciclo.ciclo : '';
          if (nombreResp) {
            self.cicloNombre = nombreResp;
          } else if (cicloSel && cicloSel.ciclo) {
            self.cicloNombre = cicloSel.ciclo;
            if (self.ciclo) {
              self.ciclo.ciclo = cicloSel.ciclo;
            }
          }
          if (data.ciclo && data.ciclo.id_ciclo) {
            var idResp = Number(data.ciclo.id_ciclo);
            if (idResp && Number(self.idCicloSeleccionado) !== idResp) {
              self.omitirWatchCiclo = true;
              self.idCicloSeleccionado = idResp;
            }
            if (!self.cicloPorId(idResp) && data.ciclo.ciclo) {
              self.ciclos = [data.ciclo].concat(self.ciclos);
            }
          }
          self.cicloSiguienteNombre =
            data.ciclo && data.ciclo.ciclo_siguiente
              ? data.ciclo.ciclo_siguiente
              : '';
          self.fechas = fechas;
          self.fechaMin = fechas.length ? fechas[0] : null;
          self.fechaMax = fechas.length ? fechas[fechas.length - 1] : null;

          if (data.fecha && data.fecha !== self.fecha) {
            self.omitirWatchFecha = true;
            self.fecha = data.fecha;
          }

          alumnos.forEach(function (a) {
            a.clave =
              String(a.escuela || a.id_unidad_negocio || '') +
              '-' +
              String(a.id || '') +
              '-' +
              String(a.id_grupo_lms || '');
            a.valorAsistenciaInicial = a.valor_asistencia;
            a.montoInicial = a.monto_pagar != null && a.monto_pagar !== '' ? Number(a.monto_pagar) : null;
            a.monto_pagar = a.montoInicial;
            a.formaPagoInicial = a.id_forma_pago ? Number(a.id_forma_pago) : null;
            a.id_forma_pago = a.formaPagoInicial;
            a.notas = a.notas || '';
            a.notasInicial = a.notas;
            a.comentarios_calidad = a.comentarios_calidad || '';
            a.comentariosCalidadInicial = a.comentarios_calidad;
            a.monto_cobrar =
              a.monto_cobrar != null && a.monto_cobrar !== '' ? Number(a.monto_cobrar) : null;
            a.hermanos = Array.isArray(a.hermanos) ? a.hermanos : [];
            a.es_hermano = !!a.es_hermano || a.hermanos.length > 0;
            a.es_becado = !!a.es_becado;
            a._guardando = false;
            a._errorGuardado = false;
            a._guardandoIntencion = false;
            a._guardandoNota = false;
            a._guardandoComentarioCalidad = false;
          });
          self.listaalumnos = alumnos;
          self.niveles = alumnos.map(function (registro) {
            return registro.id_nivel;
          });
          self.aplicarUltimaActualizacion(data);
          if (!alumnos.length) {
            self.mensajeLista = data.message
              ? data.message
              : 'El ciclo actual no devolvió alumnos para tus planteles';
          }
        })
        .catch(function (error) {
          if (requestId !== self.consultaListaId) {
            return;
          }
          self.listaalumnos = [];
          self.mensajeLista = self.obtenerMensajeError(
            error,
            'No se pudieron cargar los alumnos'
          );
          self.validarError(self.mensajeLista);
        })
        .finally(function () {
          if (requestId === self.consultaListaId) {
            self.cargandoLista = false;
          }
        });
    },

    onCambioAsistencia: function (item) {
      if (!item || !item.id) return;
      if (Number(item.valor_asistencia) === Number(item.valorAsistenciaInicial)) {
        return;
      }
      this.guardarAsistenciaAlumno(item);
    },

    guardarAsistenciaAlumno: function (item) {
      var self = this;
      if (!item || item._guardando) {
        return Promise.resolve();
      }
      this.$set(item, '_guardando', true);
      this.$set(item, '_errorGuardado', false);
      var payload = {
        id_grupo: item.id_grupo_lms,
        fecha: this.fecha,
        id_nivel: item.id_nivel,
        asistencias: [item],
        id_teacher: 0,
        escuela: item.id_unidad_negocio || item.escuela,
        id_ciclo_actividad: this.idCicloActividad(),
      };
      return this.$http
        .post('grupos.asistencias.add', payload)
        .then(function (response) {
          self.aplicarUltimaActualizacion(response.data);
          var lista =
            response.data && Array.isArray(response.data.asistencias)
              ? response.data.asistencias
              : [];
          if (lista[0] && lista[0].id_asistencia) {
            item.id_asistencia = lista[0].id_asistencia;
          }
          item.valorAsistenciaInicial = item.valor_asistencia;
        })
        .catch(function (error) {
          self.$set(item, '_errorGuardado', true);
          item.valor_asistencia = item.valorAsistenciaInicial;
          self.validarError(
            self.obtenerMensajeError(error, 'No se pudo guardar la asistencia')
          );
        })
        .finally(function () {
          self.$set(item, '_guardando', false);
        });
    },

    exportarAlumnos: function () {
      var self = this;
      var filas = this.alumnosFiltrados.map(function (item) {
        var fila = {
          Matricula: item.matricula || '',
          Alumno: item.alumno,
          Grupo: item.grupo || '',
          'Pago siguiente': self.textoEstatusPago(item),
          'Monto a pagar': item.monto_cobrar != null && item.monto_cobrar !== '' ? item.monto_cobrar : '',
          'Pago del cliente': item.monto_pagar != null && item.monto_pagar !== '' ? item.monto_pagar : '',
          'Feria / Cambio / Saldo a favor': self.textoFeria(item) === '—' ? '' : self.textoFeria(item),
          Método: self.nombreFormaPago(item.id_forma_pago) || item.metodo_pago || '',
          Notas: item.notas || '',
          Hermanos: self.textoHermanos(item),
          Asistencia: self.textoAsistencia(item),
        };
        if (self.puedeVerComentariosCalidad) {
          fila['Comentarios calidad'] = item.comentarios_calidad || '';
        }
        return fila;
      });
      if (!filas.length) {
        return this.validarErrorDirecto('No hay alumnos para exportar');
      }
      this.exportExcel(filas, 'ASISTENCIA');
    },

    idCicloAlumno: function (item) {
      var escuela = Number(item && (item.escuela || item.id_unidad_negocio));
      if (escuela === 2 && this.ciclo && this.ciclo.id_ciclo_relacionado) {
        return this.ciclo.id_ciclo_relacionado;
      }
      if (this.ciclo && this.ciclo.id_ciclo) {
        return this.ciclo.id_ciclo;
      }
      return item && item.id_ciclo ? item.id_ciclo : null;
    },

    normalizarMonto: function (valor) {
      if (valor === null || valor === undefined || valor === '') return null;
      var num = Number(valor);
      if (!Number.isFinite(num) || num < 0) return null;
      return Math.round(num * 100) / 100;
    },

    onBlurMonto: function (item) {
      if (!item || item._guardandoIntencion) return;
      var actual = this.normalizarMonto(item.monto_pagar);
      var inicial = this.normalizarMonto(item.montoInicial);
      if (actual === inicial) {
        this.$set(item, 'monto_pagar', inicial);
        return;
      }
      this.$set(item, 'monto_pagar', actual);
      this.guardarIntencionPago(item);
    },

    onCambioMetodo: function (item) {
      if (!item || item._guardandoIntencion) return;
      var actual = item.id_forma_pago ? Number(item.id_forma_pago) : null;
      var inicial = item.formaPagoInicial ? Number(item.formaPagoInicial) : null;
      if (actual === inicial) return;
      this.guardarIntencionPago(item);
    },

    guardarIntencionPago: function (item) {
      var self = this;
      var usuario = this.getdatosUsuarioERPERP || {};
      if (!item.iderp) {
        this.validarError('El alumno no tiene id ERP para guardar el pago');
        return Promise.resolve();
      }
      var idCiclo = this.idCicloAlumno(item);
      if (!idCiclo) {
        this.validarError('No se pudo determinar el ciclo para guardar el pago');
        return Promise.resolve();
      }
      var montoAnterior = item.montoInicial;
      var formaAnterior = item.formaPagoInicial;
      this.$set(item, '_guardandoIntencion', true);
      return this.$http
        .post('grupos.asistencias.intencion', {
          id_alumno: item.iderp,
          id_ciclo: idCiclo,
          monto: this.normalizarMonto(item.monto_pagar),
          id_forma_pago: item.id_forma_pago || null,
          id_usuario: usuario.iderp,
          id_ciclo_actividad: this.idCicloActividad(),
        })
        .then(function (response) {
          var data = response.data || {};
          self.aplicarUltimaActualizacion(data);
          var monto =
            data.monto != null ? Number(data.monto) : self.normalizarMonto(item.monto_pagar);
          var forma = data.id_forma_pago ? Number(data.id_forma_pago) : item.id_forma_pago || null;
          self.$set(item, 'monto_pagar', monto);
          self.$set(item, 'montoInicial', monto);
          self.$set(item, 'id_forma_pago', forma);
          self.$set(item, 'formaPagoInicial', forma);
        })
        .catch(function (error) {
          self.$set(item, 'monto_pagar', montoAnterior);
          self.$set(item, 'id_forma_pago', formaAnterior);
          self.validarError(
            self.obtenerMensajeError(error, 'No se pudo guardar el monto o el método')
          );
        })
        .finally(function () {
          self.$set(item, '_guardandoIntencion', false);
        });
    },

    onBlurNota: function (item) {
      if (!item || item._guardandoNota) return;
      var actual = item.notas != null ? String(item.notas).trim() : '';
      var inicial = item.notasInicial != null ? String(item.notasInicial).trim() : '';
      if (actual === inicial) {
        this.$set(item, 'notas', inicial);
        return;
      }
      this.$set(item, 'notas', actual);
      this.guardarNotaAlumno(item);
    },

    guardarNotaAlumno: function (item) {
      var self = this;
      var usuario = this.getdatosUsuarioERPERP || {};
      var idAlumno = item.iderp || item.id;
      if (!idAlumno) {
        this.validarError('El alumno no tiene id para guardar la nota');
        return Promise.resolve();
      }
      var anterior = item.notasInicial;
      this.$set(item, '_guardandoNota', true);
      return this.$http
        .post('grupos.asistencias.nota', {
          id_alumno: idAlumno,
          id_alumno_lms: item.id,
          comentario: item.notas || '',
          id_usuarioerp: usuario.iderp,
          id_grupo: item.id_grupo_erp || item.id_grupo_lms,
          id_ciclo: this.idCicloAlumno(item),
          id_ciclo_actividad: this.idCicloActividad(),
          idperfil: usuario.idpuesto,
          unidad_negocio: item.id_unidad_negocio || item.escuela,
          grupo: item.grupo,
          perfil: usuario.puesto,
        })
        .then(function (response) {
          var data = response.data || {};
          self.aplicarUltimaActualizacion(data);
          var texto =
            data.comentario != null ? String(data.comentario) : String(item.notas || '');
          self.$set(item, 'notas', texto);
          self.$set(item, 'notasInicial', texto);
        })
        .catch(function (error) {
          self.$set(item, 'notas', anterior);
          self.validarError(
            self.obtenerMensajeError(error, 'No se pudo guardar la nota')
          );
        })
        .finally(function () {
          self.$set(item, '_guardandoNota', false);
        });
    },

    onBlurComentarioCalidad: function (item) {
      if (!item || item._guardandoComentarioCalidad) return;
      var actual = item.comentarios_calidad != null ? String(item.comentarios_calidad).trim() : '';
      var inicial = item.comentariosCalidadInicial != null
        ? String(item.comentariosCalidadInicial).trim()
        : '';
      if (actual === inicial) {
        this.$set(item, 'comentarios_calidad', inicial);
        return;
      }
      this.$set(item, 'comentarios_calidad', actual);
      this.guardarComentarioCalidadAlumno(item);
    },

    guardarComentarioCalidadAlumno: function (item) {
      var self = this;
      var usuario = this.getdatosUsuarioERPERP || {};
      if (!item.iderp) {
        this.validarError('El alumno no tiene id ERP para guardar el comentario de calidad');
        return Promise.resolve();
      }
      var idCiclo = this.idCicloAlumno(item);
      if (!idCiclo) {
        this.validarError('No se pudo determinar el ciclo para guardar el comentario de calidad');
        return Promise.resolve();
      }
      var anterior = item.comentariosCalidadInicial;
      this.$set(item, '_guardandoComentarioCalidad', true);
      return this.$http
        .post('grupos.asistencias.comentario.calidad', {
          id_alumno: item.iderp,
          id_ciclo: idCiclo,
          comentario: item.comentarios_calidad || '',
          id_usuario: usuario.iderp,
          id_ciclo_actividad: this.idCicloActividad(),
        })
        .then(function (response) {
          var data = response.data || {};
          self.aplicarUltimaActualizacion(data);
          var texto =
            data.comentario != null
              ? String(data.comentario)
              : String(item.comentarios_calidad || '');
          self.$set(item, 'comentarios_calidad', texto);
          self.$set(item, 'comentariosCalidadInicial', texto);
        })
        .catch(function (error) {
          self.$set(item, 'comentarios_calidad', anterior);
          self.validarError(
            self.obtenerMensajeError(error, 'No se pudo guardar el comentario de calidad')
          );
        })
        .finally(function () {
          self.$set(item, '_guardandoComentarioCalidad', false);
        });
    },
  },
};
</script>

<style scoped>
.asistencia-page {
  max-width: 100% !important;
}

.page-card {
  border-radius: 8px;
  overflow: hidden;
}

.page-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.page-title {
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.3;
  margin: 0;
  color: rgba(0, 0, 0, 0.87);
}

.page-subtitle {
  font-size: 0.8125rem;
  color: rgba(0, 0, 0, 0.54);
  margin-top: 4px;
}

.page-subtitle__dot {
  margin: 0 4px;
}

.page-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.page-actions__meta {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.54);
  line-height: 1.3;
  max-width: 280px;
  text-align: right;
}

.page-actions__btn {
  text-transform: none;
  letter-spacing: 0;
  font-weight: 500;
}

.filters-row >>> .v-input {
  font-size: 0.875rem;
}

.asistencia-table {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
}

.asistencia-table >>> thead th {
  font-size: 0.875rem !important;
  font-weight: 600 !important;
  color: rgba(0, 0, 0, 0.6) !important;
  background: #fafafa !important;
}

.asistencia-table >>> tbody td {
  font-size: 0.9375rem !important;
}

.alumno-nombre {
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.3;
}

.alumno-matricula {
  font-size: 0.8125rem;
  color: rgba(0, 0, 0, 0.54);
}

.icono-telefono {
  cursor: pointer;
}

.chip-reporte {
  cursor: pointer;
  font-weight: 600;
  min-width: 36px;
  justify-content: center;
}

.reporte-total td {
  font-weight: 700 !important;
  background: #f5f5f5 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

.texto-tabla,
.monto-texto {
  font-size: 0.9375rem;
  font-weight: 600;
}

.monto-input,
.metodo-input,
.nota-input {
  font-size: 0.9rem;
}

.asistencia-radios-wrap {
  white-space: nowrap;
}

.asistencia-radios >>> .v-input--radio-group__input {
  flex-wrap: nowrap !important;
}

.asistencia-radios >>> .v-radio {
  margin-right: 6px !important;
}

.asistencia-letra {
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
  cursor: default;
}

.asistencia-table >>> tbody tr.fila-debe {
  background: #ffcdd2 !important;
}

.asistencia-table >>> tbody tr.fila-debe:hover {
  background: #ef9a9a !important;
}

.asistencia-table >>> tbody tr.fila-pagado {
  background: #c8e6c9 !important;
}

.asistencia-table >>> tbody tr.fila-pagado:hover {
  background: #a5d6a7 !important;
}

.asistencia-table >>> tbody tr.fila-becado {
  background: #e1bee7 !important;
}

.asistencia-table >>> tbody tr.fila-becado:hover {
  background: #ce93d8 !important;
}

.asistencia-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 8px;
  height: 8px;
}

.asistencia-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: #babcbf;
  border-radius: 8px;
}
</style>
